import React, { useContext, useRef, useEffect } from 'react';

import { CloseIcon } from '$partials/icon';
import { ModalContext } from '$contexts/modal.jsx';
import { useCursorContext } from '$contexts/cursor.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').TenancyInfoModal}
 */
const TenancyInfoModal = ({
    tenancyInfo
}) => {
    const { handleModal } = useContext(ModalContext);
    const { dispatch: cursorDispatch } = useCursorContext();
    const exitButtonRef = useRef(null);
    const {
        description = '' ,
        text = [],
        note = ''
    } = tenancyInfo || {};

    useEffect(() => {
        const exit = cursorDispatch({
            type: 'registerArea',
            data: {
                ref: exitButtonRef,
                cursorType: 'exit'
            },
        });

        return () => [exit].map(cleanup => {
            cleanup();});
    }, []);

    return (
        <>
            <div
                className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-black mix-blend-multiply z3 cursor-none'}
                onClick={() => handleModal()}
                ref={exitButtonRef}
                style={{opacity: '0.2'}}>
            </div>
            <div className='height-100 bg-white z4 fixed top-0 overflow-auto modal-container'>
                <button
                    aria-label='Close'
                    className='form-field-reset link-reset absolute right-0 right mt6 mr6 cursor-pointer'
                    onClick={() => handleModal()}
                    type='button'>
                    <CloseIcon/>
                </button>
                <div className='py7 px6'>
                    <h2 className='type-style-2'>Tenancy Info</h2>
                    <div
                        className='col-9 mt5 mb7 type-style-6'
                        dangerouslySetInnerHTML={{__html: description}} />


                    {text?.map((text, i) => {
                        return (
                            <span key={`tenancy-info-text-${i}`}>
                                <hr className='black'/>
                                <p className='type-style-5 py6'>{text?.title}</p>
                                <div
                                    className='mb7 type-style-6 rich-text tenancy-info'
                                    dangerouslySetInnerHTML={{__html: text?.body}} />
                            </span>
                        );
                    })}

                    {note && (
                        <>
                            <hr className='black'/>
                            <div
                                className='my6 type-style-7 rich-text'
                                dangerouslySetInnerHTML={{__html: note}} />
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TenancyInfoModal ;
